import { Injectable } from '@angular/core';
import { ApiService } from '../api.service';
import { Observable } from 'rxjs';
import { HydraCollection } from '../hydra/hydra-collection';
import { UserProfileModel } from '@core/api/models/user/user-profile.model';


@Injectable({
  providedIn: 'root'
})
export class UserProfileApiService extends ApiService {
  readonly resourcePath = 'user_profiles';

  list(filters: Record<string, string> = {}): Observable<HydraCollection<UserProfileModel>> {
    return this.restList<UserProfileModel>(filters);
  }

  get(id: string): Observable<UserProfileModel> {
    return this.restRead<UserProfileModel>(id);
  }

  update(id: string, data: object): Observable<UserProfileModel> {
    return this.restUpdate<UserProfileModel>(id, data);
  }

  validateUserName(name:string, organisationProfileId:string = ''){
    const filter = organisationProfileId ? '&organisationProfileId='+organisationProfileId:''
    return this.http.get<any>(this.apiUrl+'/me/userprofile/user/validateusername?query='+name+filter);
  }

  getCV(id:string){
    return this.http.get<any>(this.resourceUrl+'/'+id+'/training_cv')
  }
}
